/**@author */
import React, { useMemo } from "react";
import { KeyboardTypeOptions, StyleProp, StyleSheet, TextStyle, useWindowDimensions } from "react-native";
import { HelperText, TextInput, useTheme } from "react-native-paper";
import { Block } from "../../blocks/block";

interface TextInputMultilineProps {
  name: string;
  inputProps?: object;
  style?: StyleProp<TextStyle>;
  label?: string;
  value?: string;
  note?: string;
  keyboardType?: KeyboardTypeOptions;
  rightContent?: JSX.Element;
  rightAffix?: boolean;
}

export const TextInputMultiline = (props: TextInputMultilineProps) => {
  const { name, inputProps, style = {}, label, value, note, keyboardType = "default", rightContent } = props;
  const { colors, fonts } = useTheme();
  const { width } = useWindowDimensions();
  // Ngăn ngừa re-render khi bắt sự kiện onBlur;
  const [heightInput, setHeightInput] = React.useState<number | undefined>();
  const ref = React.createRef<any>();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        inputStyle: {
          flex: 1,
          color: colors.accent,
          backgroundColor: colors.backgroundForm,
          fontWeight: "700",
          textShadowColor: "black",
          height: heightInput,
        },
        textAffix: { fontFamily: fonts.regular.fontFamily, fontSize: 8 },
      }),
    [colors, fonts, heightInput],
  );

  React.useEffect(() => {
    setHeightInput(undefined);
  }, [width]);

  return (
    <>
      <Block row center>
        <TextInput
          mode={"flat"}
          key={name}
          outlineColor={"transparent"}
          theme={{
            colors: {
              primary: colors.accent,
              text: colors.accent,
            },
          }}
          style={[styles.inputStyle, style]}
          keyboardType={keyboardType}
          ref={ref}
          value={value}
          label={label}
          autoCompleteType="off"
          {...inputProps}
          multiline
          onContentSizeChange={(e) => {
            setHeightInput(e.nativeEvent.contentSize.height);
          }}
        />
        <>{rightContent}</>
      </Block>
      {note?.length && (
        <HelperText type="info" visible={note?.length ? true : false}>
          {note}
        </HelperText>
      )}
    </>
  );
};
